import defaultStore from '../defaultStore';
import { DETAILS_DATA_TO_LIST } from "@/store/types";

const { store } = defaultStore('venusa/order_all', 'order_all');

function transformData(data)
{
  let status = data.STATUS_HEADER

  if (['registrado', 'ingresado'].includes(status.toLowerCase())) {
    data.STATUS_PEDIDO = 'registrado_pedido'
  } else {
    data.STATUS_PEDIDO = data.STATUS_HEADER
  }

  return data
}

store.getters.getData = (state) => {
  const data = state.data

  if (!data.ID) {
    return data
  }

  return transformData(data)
}

store.actions.setFilterItems = ({ commit }, data) => {
  commit(DETAILS_DATA_TO_LIST, {
    data: data
  })
}

store.mutations.setDataToList = (state, payload) => {
  let { data } = payload

  state.list = data.map(item => transformData(item))
}

export default {
  ...store,
};
